export const Resource = {
  // ROOT RESOURCES
  Tenants: 'Tenants',
  Admin: 'Admin',
  Hangfire: 'Hangfire',
  Users: 'Users',
  UserRoles: 'UserRoles',
  Roles: 'Roles',
  RoleClaims: 'RoleClaims',

  // Basic
  Dashboard: 'Dashboard',
  Messenger: 'Messenger',
  Settings: 'Settings',

  // Webpage and blog resources
  Cms: 'Cms',
  Website: 'Website',
  Blog: 'Blog',
  IdCard: 'IdCard',

  // WMS / CRM
  MyCompany: 'MyCompany',
  Offer: 'Offer',
  Order: 'Order',
  Inventory: 'Inventory',
  Products: 'Products',
  Services: 'Services',
  Categories: 'Categories',
  CalendarPersonal: 'CalendarPersonal',
  CalendarCompany: 'CalendarCompany',
  Brands: 'Brands',
  Customers: 'Customers',
  CustomersNotes: 'CustomersNotes',
  Analytics: 'Analytics',
  Invoicing: 'Invoicing'
} as const;

export type ResourceType = (typeof Resource)[keyof typeof Resource];
